// extracted by mini-css-extract-plugin
export default {"no-data":"styles-module__no-data___KPvZP","message":"styles-module__message___4l8g1","big_screen":"styles-module__big_screen___GhFpd"};